import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import audioService from '../services/audioService';
import SidebarItem, { NavCountBadgeUrgent } from './sidebar/SidebarItem';

const CommandesBadge = ({ pendingCount, connected, onClick, isActive = false }) => {
  const navigate = useNavigate();
  const hasNewCommandes = pendingCount > 0;

  const handleClick = () => {
    audioService.stopRepeat();
    if (onClick) onClick();
    else navigate('/commandes');
  };

  return (
    <SidebarItem
      icon={ShoppingCart}
      label="Mes Commandes"
      active={isActive}
      onClick={handleClick}
      title={
        hasNewCommandes
          ? `${pendingCount} commande(s) en attente${connected ? ' — temps réel actif' : ''}`
          : 'Aucune commande en attente'
      }
      badge={hasNewCommandes ? <NavCountBadgeUrgent count={pendingCount} /> : null}
    />
  );
};

export default CommandesBadge;
